const getters = {
    allManagedInstructions: (state) => state.managedInstructionList.data,
    allManagedInstructionsPending: (state) => state.managedInstructionList.status.pending,
};

export default getters;
